<span class="app-link" [ngSwitch]="urlType">
  <a *ngSwitchCase="linkTypeEnum.URL" [id]="id" [href]="url" [class]="styleClass">{{ label }}</a>
  <a
    *ngSwitchCase="linkTypeEnum.ROUTER_LINK"
    [id]="id"
    [routerLink]="url"
    [class]="styleClass"
    [ngClass]="{ 'active': isActive }"
  >
    {{ label }}
  </a>
  <a *ngSwitchCase="linkTypeEnum.URL_NEW_TAB"
      [href]="url"
      target="_blank"
      [class]="styleClass"
  >
    {{label}}
  </a>
  <span *ngSwitchDefault [id]="id" [class]="styleClass">{{ label }}</span>
</span>
